import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
  DialogBackdrop,
  DialogPanel,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { LocalizedLink } from '../LocalizedLink/LocalizedLink';

export const Backdrop = styled(DialogBackdrop)`
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  inset: 0;
  z-index: 1000;
`;

export const TransitionDiv = styled.div`
  &.transition {
    transition: transform 0.3s ease-out;
  }

  &.out {
    transform: translateX(var(--sidemenu-width));
  }

  &.in {
    transform: translateX(0);
  }
`;

export const MenuContainer = styled.div`
  position: fixed;
  right: 0;
  inset-block: 0;
  z-index: 1001;
`;

export const Menu = styled(DialogPanel)`
  background: var(--color-white);
  width: var(--sidemenu-width);
  height: 100dvh;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  display: flex;
  justify-content: flex-end;
  margin-block-start: var(--spacing-8);
  margin-inline-end: var(--spacing-8);
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  display: flex;
  cursor: pointer;
  padding: var(--spacing-4);
  color: var(--color-black);
  border-radius: var(--border-radius-s);
  transition: all 0.3s;

  &:hover {
    background-color: var(--color-neutral-20);
  }
`;

export const Content = styled.div`
  overflow-y: auto;
`;

export const Group = styled.div`
  padding: var(--spacing-8);
`;

export const NestedGroup = styled(DisclosurePanel)`
  padding-inline-start: var(--spacing-32);
  transition:
    opacity 0.3s,
    transform 0.3s ease-in-out;

  &[data-closed] {
    transform: translateY(calc(var(--spacing-4) * -1));
    opacity: 0;
  }
`;

const MenuItem = css`
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--spacing-12);
  padding: var(--spacing-16);
  font: var(--font-link-l);
  color: var(--color-black);
  text-decoration: none;
  border-radius: var(--border-radius-s);
  transition: all 0.3s;

  svg {
    width: var(--spacing-20);
    height: var(--spacing-20);
  }

  &:hover {
    background-color: var(--color-neutral-20);
  }
`;

const MenuButtonItem = css`
  ${MenuItem}
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const ToggleExpandButton = styled(DisclosureButton)`
  ${MenuButtonItem}

  [data-indicator] {
    transition: all 0.3s;
  }

  &[data-open] [data-indicator] {
    transform: rotate(180deg);
  }
`;

export const Link = styled(LocalizedLink)`
  ${MenuItem}
`;

export const StyledButton = styled.button`
  ${MenuButtonItem}
`;

export const Separator = styled.div`
  background: var(--color-neutral-30);
  width: 100%;
  height: 1px;
`;

export const Chevron = styled(KeyboardArrowDownIcon)`
  margin-inline-start: auto;
`;
